import {
  DICTATE_REENGAGEMENT_FLAG_KEY,
  DICTATE_REENGAGEMENT_VIEW_EXPERIMENT_KEY,
  type DictateReengagementHintVersion,
} from '@/features/flags/dictate-reengagement-flag';
import { useManualExposure } from '@/hooks/amplitude/use-manual-exposure';
import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { ScreenName } from '@heidi/runtime/analytics-vocabulary';

export const trackDictateReengagementViewed = (
  variant: DictateReengagementHintVersion | 'general_card'
): void => {
  track({
    event_name: TrackingEventName.ScreenViewed,
    props: {
      screen_name: ScreenName.DictateReengagement,
      version: variant,
    },
    options: { amplitude: false },
  });
};

export const useDictateReengagementViewExposure = (
  variant: DictateReengagementHintVersion,
  isVisible: boolean
): void => {
  useManualExposure({
    flagKey: DICTATE_REENGAGEMENT_FLAG_KEY,
    experimentKey: DICTATE_REENGAGEMENT_VIEW_EXPERIMENT_KEY,
    isEnabled: null,
    variant,
    isVisible,
  });
};
